import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import ToursList from "./pages/ToursList";
import TourEditor from "./pages/TourEditor";
import ReviewFlow from "./pages/ReviewFlow";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/r/:tourId" element={<ReviewFlow />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/tours"
                element={
                  <ProtectedRoute>
                    <ToursList category="tour" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/tours/:id"
                element={
                  <ProtectedRoute>
                    <TourEditor category="tour" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/restaurants"
                element={
                  <ProtectedRoute>
                    <ToursList category="restaurant" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/restaurants/:id"
                element={
                  <ProtectedRoute>
                    <TourEditor category="restaurant" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/hotels"
                element={
                  <ProtectedRoute>
                    <ToursList category="hotel" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/hotels/:id"
                element={
                  <ProtectedRoute>
                    <TourEditor category="hotel" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/services"
                element={
                  <ProtectedRoute>
                    <ToursList category="service" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dashboard/services/:id"
                element={
                  <ProtectedRoute>
                    <TourEditor category="service" />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
